routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.specificActList', {
      url: "/consultas/actividades-especificas",
      template: `<specific-act-list  sh-ctrl="shCtrl"></specific-act-list>`,
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/specific-act-list/specific-act-list.config.js
 **/